import { render, staticRenderFns } from "./PendingTask.vue?vue&type=template&id=4bcbb5cb&scoped=true"
import script from "./PendingTask.vue?vue&type=script&lang=js"
export * from "./PendingTask.vue?vue&type=script&lang=js"
import style0 from "./PendingTask.vue?vue&type=style&index=0&id=4bcbb5cb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bcbb5cb",
  null
  
)

export default component.exports